export default function HelpOverlay(props: { onClose: () => void }) {
  return (
    <div
      class="overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="help-title"
      onClick={props.onClose}
    >
      <div class="overlay-card" onClick={(e) => e.stopPropagation()}>
        <div class="overlay-head">
          <h2 id="help-title">Keyboard shortcuts</h2>
          <button
            class="overlay-close"
            type="button"
            onClick={props.onClose}
            aria-label="Close help"
          >
            &times;
          </button>
        </div>
        <table class="kbd-table">
          <tbody>
            <tr><td><kbd>&#8984;</kbd><kbd>K</kbd> / <kbd>Ctrl</kbd><kbd>K</kbd></td><td>Search firms (Spotlight)</td></tr>
            <tr><td><kbd>g</kbd></td><td>Back to firm grid</td></tr>
            <tr><td><kbd>/</kbd></td><td>Focus inline search (on grid)</td></tr>
            <tr><td><kbd>[</kbd></td><td>Previous firm (on detail)</td></tr>
            <tr><td><kbd>]</kbd></td><td>Next firm (on detail)</td></tr>
            <tr><td><kbd>1</kbd> to <kbd>5</kbd></td><td>Switch tab (on detail)</td></tr>
            <tr><td><kbd>?</kbd></td><td>Show this help</td></tr>
            <tr><td><kbd>Esc</kbd></td><td>Close panel</td></tr>
          </tbody>
        </table>
        <div class="overlay-foot">Press <kbd>?</kbd> anytime to reopen.</div>
      </div>
    </div>
  );
}
